define.alias("shared/components/shared/profile-categorization/rewards-steps/report", "settings/components/shared/profile-categorization/rewards-steps/report");